
import { Suspense } from "react";
import { Header } from "@/components/home/Header";
import { HeroSection } from "@/components/home/HeroSection";
import { FeaturesGrid } from "@/components/home/FeaturesGrid";
import { UserTypes } from "@/components/home/UserTypes";
import ProcessSteps from "@/components/home/ProcessSteps";
import { CTASection } from "@/components/home/CTASection";
import { Footer } from "@/components/home/Footer";
import { Skeleton } from "@/components/ui/skeleton";

const LoadingSkeleton = () => (
  <div className="space-y-8">
    <Skeleton className="h-[400px] w-full" />
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} className="h-[200px] w-full" />
        ))}
      </div>
    </div>
  </div>
);

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Header />
      <Suspense fallback={<LoadingSkeleton />}>
        <main>
          <HeroSection />
          <ProcessSteps />
          <FeaturesGrid />
          <UserTypes />
          <div className="container mx-auto px-4 py-16">
            <CTASection />
          </div>
        </main>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
